export default __webpack_public_path__ + "static/media/discount2.ca893294.jpg";